import { PlayerType } from "mannequin/src/types/player";

export enum PoserPlayerType {
  BATTER = "batter",
  RUNNER = "runner",
  CATCHER = "catcher",
  PITCHER = "pitcher",
  FIELDER = "fielder",
  UMPIRE = "umpire",
  PLATE_UMPIRE = "plate-umpire",
  COACH = "coach",
}

export function getPoserPlayerType(id: number): PoserPlayerType {
  switch (id) {
    case 1:
      return PoserPlayerType.PITCHER;
    case 10:
      return PoserPlayerType.BATTER;
    case 11:
    case 12:
    case 13:
      return PoserPlayerType.RUNNER;
    case 2:
      return PoserPlayerType.CATCHER;
    case 18:
    case 19:
      return PoserPlayerType.COACH;
    case 14:
      return PoserPlayerType.PLATE_UMPIRE;
    case 15:
    case 16:
    case 17:
    case 20:
    case 21:
      return PoserPlayerType.UMPIRE;
    default:
      return PoserPlayerType.FIELDER;
  }
}

// TODO: rework dependency on playertype / positionId in poser codebase
export function poserPlayerTypeFromMannequin(
  playerType: PlayerType
): PoserPlayerType {
  switch (playerType) {
    case PlayerType.BATTER:
      return PoserPlayerType.BATTER;
    case PlayerType.CATCHER:
      return PoserPlayerType.CATCHER;
    case PlayerType.PITCHER:
      return PoserPlayerType.PITCHER;
    case PlayerType.FIELDER:
      return PoserPlayerType.FIELDER;
    case PlayerType.UMPIRE:
      return PoserPlayerType.UMPIRE;
    case PlayerType.PLATE_UMPIRE:
      return PoserPlayerType.PLATE_UMPIRE;
    case PlayerType.COACH:
      return PoserPlayerType.COACH;
    default:
      return PoserPlayerType.FIELDER;
  }
}
